import { render, staticRenderFns } from "./AppCenter.vue?vue&type=template&id=88df81e0&scoped=true&"
import script from "./AppCenter.vue?vue&type=script&lang=js&"
export * from "./AppCenter.vue?vue&type=script&lang=js&"
import style0 from "./AppCenter.vue?vue&type=style&index=0&id=88df81e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88df81e0",
  null
  
)

export default component.exports